import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod } from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  AllState_LIST_START: "AllState_LIST_START",
  AllState_LIST_SUCCESS: "AllState_LIST_SUCCESS",
  AllState_LIST_FAILED: "AllState_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const AllStateListStart = (data) => ({
  type: actionType.AllState_LIST_START,
  payload: data,
});

export const AllStateListSuccess = (data) => ({
  type: actionType.AllState_LIST_SUCCESS,
  payload: data,
});

export const AllStateListFailed = (data) => ({
  type: actionType.AllState_LIST_FAILED,
  payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null,
};

export default function AllStateListReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.AllState_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case actionType.AllState_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case actionType.AllState_LIST_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* AllStateListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      const AllState = response.data.data.allStates?.States
        ? response.data.data.allStates?.States
        : null;
      let finalData = [];
      yield put(AllStateListSuccess(AllState));
    } else {
      messagePopup("", "COLLEGE List failed", "error");
      yield put(AllStateListFailed("AllState List failed"));
    }
  } catch (error) {
    messagePopup("", "AllState List failed", "error");
    yield put(AllStateListFailed("AllState List failed"));
  }
}

export function* watchAllStateListSaga() {
  yield takeEvery(actionType.AllState_LIST_START, AllStateListSaga);
}
